import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { BaseComponent } from '@/types';

/**
 * LLM Integration Section Component
 * Highlights the advanced LLM integration capabilities
 */
export function LLMIntegration({ className }: BaseComponent) {
  const features = [
    'LLM Management Support with intelligent scaling',
    'Stripe Integration for seamless billing and usage tracking',
    'Real-time system interaction with AI-powered command generation',
    'Natural language processing for complex infrastructure tasks',
  ];

  return (
    <section className={cn("py-20", className)}>
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="gradient-card rounded-2xl p-8 shadow-card space-y-6">
            <h2 className="text-3xl lg:text-4xl font-bold">
              Advanced LLM Integration
            </h2>
            
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle className="w-6 h-6 text-primary mt-1 flex-shrink-0" />
                  <p className="text-foreground">{feature}</p>
                </div>
              ))}
            </div>
            
            <Button className="bg-primary hover:bg-primary/90">
              Learn More
            </Button>
          </div>
          
          {/* Image */}
          <div className="relative">
            <img 
              src="/images/llm-integration.jpg" 
              alt="LLM Integration" 
              className="rounded-2xl shadow-elegant w-full"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
